// src/pages/Employee/CreateEmployee/steps/Step6Documents.tsx
import React from 'react';
import { Row, Col, FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import { DocumentsData, StepProps } from '../../types/employee.types';
import FileUploadField from './fileuploadfile';

const Step6Documents: React.FC<StepProps<DocumentsData>> = ({ data, onChange, errors }) => {
  const set = (field: keyof DocumentsData, value: any) => {
    onChange({ ...data, [field]: value });
  };

  return (
    <div>
      <h6 className="mb-3">Identity &amp; Statutory Documents</h6>
      <Row>
        <Col md={6}>
          <FormGroup>
            <Label className="fw-bold text-muted small text-uppercase">PAN Number</Label>
            <Input
              value={data.pan_number}
              invalid={!!errors.pan_number}
              style={{ textTransform: 'uppercase' }}
              maxLength={10}
              onChange={(e) => set('pan_number', e.target.value.toUpperCase())}
            />
            <FormFeedback>{errors.pan_number}</FormFeedback>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label className="fw-bold text-muted small text-uppercase">EPF UAN</Label>
            <Input value={data.epf_uan} onChange={(e) => set('epf_uan', e.target.value)} />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <FileUploadField
            label="PAN Card"
            value={data.pan_attachment}
            onChange={(v) => set('pan_attachment', v)}
          />
        </Col>
        <Col md={6}>
          <FileUploadField
            label="Aadhar Card"
            value={data.aadhar_attachment}
            onChange={(v) => set('aadhar_attachment', v)}
          />
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <FileUploadField
            label="EPF Document"
            value={data.epf_attachment}
            onChange={(v) => set('epf_attachment', v)}
          />
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label className="fw-bold text-muted small text-uppercase">ESIC Number</Label>
            <Input value={data.esic_number} onChange={(e) => set('esic_number', e.target.value)} />
          </FormGroup>
          <FileUploadField
            label="ESIC Document"
            value={data.esic_attachment}
            onChange={(v) => set('esic_attachment', v)}
          />
        </Col>
      </Row>

      <div className="border-top pt-3 mt-2">
        <h6 className="mb-3">Resume &amp; Payslips</h6>
        <Row>
          <Col md={6}>
            <FileUploadField
              label="Resume"
              value={data.resume}
              onChange={(v) => set('resume', v)}
            />
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <FileUploadField
              label="Payslip 1 (most recent)"
              value={data.payslip_1}
              onChange={(v) => set('payslip_1', v)}
            />
          </Col>
          <Col md={4}>
            <FileUploadField
              label="Payslip 2"
              value={data.payslip_2}
              onChange={(v) => set('payslip_2', v)}
            />
          </Col>
          <Col md={4}>
            <FileUploadField
              label="Payslip 3"
              value={data.payslip_3}
              onChange={(v) => set('payslip_3', v)}
            />
          </Col>
        </Row>
        <div className="text-muted small">Payslips are optional and only needed if the candidate has prior work experience.</div>
      </div>
    </div>
  );
};

export default Step6Documents;